<div class="customers">
    <div class="divObjetivo">
        <div class="card-body">
            <div class="form-special-padding">
                <div class="row">
                    <div class="col-sm-4" style="background-color: #E8EAF5;">
                        <textarea name="{{ 'objetivoTexto_' + indice }}" type="text" [(ngModel)]="objetivoArea.objetivoTexto" class="text-area-objetivo" (change)="change()" [disabled]="simulacion"></textarea>
                    </div>
                    <div class="col-sm-4" style="background-color: #E8EAF5;">
                        <textarea name="{{ 'meta' + indice }}" type="text" class="text-area-objetivo" [(ngModel)]="objetivoArea.meta" (change)="change()" [disabled]="simulacion"></textarea>
                    </div>
                    <div class="col-sm-4" style="background-color: #E8EAF5;">
                        <textarea name="{{ 'estrategia1_' + indice }}" type="text" class="text-area-objetivo" [(ngModel)]="objetivoArea.estrategia1" style="height: 70px;margin-bottom: 0px;" (change)="change()" [disabled]="simulacion"></textarea>
                        <textarea name="{{ 'estrategia2_' + indice }}" type="text" class="text-area-objetivo" [(ngModel)]="objetivoArea.estrategia2" style="height: 70px;margin-bottom: 0px;margin-top: 0px;" (change)="change()" [disabled]="simulacion"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>